import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import './amplifyConfig';
import './index.css';

import Sidebar from './components/Sidebar';
import AdvertiserList from './pages/AdvertiserList';
import Keywords from './pages/Keywords';
import Scrape from './pages/Scrape';
import MailSettings from './pages/MailSettings';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30000 } },
});

const App: React.FC = () => {
  return (
    <Authenticator loginMechanisms={['email']}>
      {() => (
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <div className="layout">
              <Sidebar />
              <main className="main-content">
                <Routes>
                  <Route path="/"              element={<AdvertiserList />} />
                  <Route path="/keywords"      element={<Keywords />} />
                  <Route path="/scrape"        element={<Scrape />} />
                  <Route path="/mail-settings" element={<MailSettings />} />
                </Routes>
              </main>
            </div>
          </BrowserRouter>
        </QueryClientProvider>
      )}
    </Authenticator>
  );
};

export default App;
